import React from'react';
import {observer} from 'mobx-react-lite'
import clubStore from '../../../storage/ClubStore'

const ParentMenu = () => {
  if (!clubStore.club.is_parent) return null;
  return (
    <div>
      <h1>Parent Menu</h1>
    </div>
  );
};

export default observer(ParentMenu);